module.exports = __webpack_public_path__ + "static/img/son6_active.76d645ae.png";